import {Menu} from '@mantine/core';
import {useAtom} from 'jotai';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useToken from 'modules/auth/atoms/use-token';
import React from 'react';
import {AiFillPrinter} from 'react-icons/ai';
import {FaCity, FaStore} from 'react-icons/fa';
import {HiOutlineBars3} from 'react-icons/hi2';
import {
  IoCodeSharp,
  IoExit,
  IoMoon,
  IoPerson,
  IoShuffle,
  IoSunny,
} from 'react-icons/io5';
import {useQueryClient} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {MainButton, MainTitle} from 'shared/components/drawer-option/styles';
import {filterAtom} from 'shared/migration-hooks/use-projection';
import styled, {useTheme} from 'styled-components';

const NavigationFooter: React.FC = () => {
  const theme = localStorage.getItem('theme');
  const {setToken} = useToken();
  const {accessControl, setCompanyId, setCityId, setFranchiseAccessControl} =
    useAccessControls();
  const queryClient = useQueryClient();
  const [_, setFilters] = useAtom(filterAtom);
  const {colors} = useTheme();
  const navigate = useNavigate();

  return (
    <Menu
      shadow="md"
      width={240}
      position="top-start"
      styles={{dropdown: {backgroundColor: colors.card}}}>
      <Menu.Target>
        <Container>
          <MainButton>
            <HiOutlineBars3 />
            <MainTitle>OPÇÕES</MainTitle>
          </MainButton>
        </Container>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Geral</Menu.Label>
        <Menu.Item
          leftSection={<IoPerson />}
          onClick={() => navigate('/profile')}>
          Meus dados
        </Menu.Item>
        {accessControl?.cityId && (
          <Menu.Item
            leftSection={<FaCity />}
            onClick={() =>
              navigate(`/settings/cities/${accessControl.cityId}`)
            }>
            Gerenciar cidade
          </Menu.Item>
        )}
        {accessControl?.companyId && (
          <Menu.Item
            leftSection={<FaStore />}
            onClick={() =>
              navigate(`/settings/companies/${accessControl.companyId}`)
            }>
            Gerenciar empresa
          </Menu.Item>
        )}
        {theme !== 'dark' && (
          <Menu.Item
            leftSection={<IoMoon />}
            onClick={() => {
              localStorage.setItem('theme', 'dark');
              window.location.reload();
            }}>
            Modo escuro
          </Menu.Item>
        )}
        {theme === 'dark' && (
          <Menu.Item
            leftSection={<IoSunny />}
            onClick={() => {
              localStorage.setItem('theme', 'light');
              window.location.reload();
            }}>
            Modo claro
          </Menu.Item>
        )}
        <Menu.Item
          leftSection={<AiFillPrinter />}
          onClick={() =>
            window.open(
              'https://www.mediafire.com/file/pws8t2ghb2eksmj/uau-delivery.exe/file',
              '_blank',
            )
          }>
          Impressora
        </Menu.Item>

        <Menu.Item leftSection={<IoCodeSharp />}>Versão 0.0.3</Menu.Item>

        <Menu.Divider />

        <Menu.Label>Acesso</Menu.Label>
        <Menu.Item
          leftSection={<IoShuffle />}
          onClick={() => {
            queryClient.clear();
            setCityId(null);
            setCompanyId(null);
            setFranchiseAccessControl(null);
            setFilters({});
          }}>
          Alterar acesso
        </Menu.Item>
        <Menu.Item
          color="red"
          leftSection={<IoExit />}
          onClick={() => {
            setToken(null);
            queryClient.clear();
            setCityId(null);
            setCompanyId(null);
            setFranchiseAccessControl(null);
            localStorage.clear();
          }}>
          Sair
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default NavigationFooter;

const Container = styled.div`
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 60px;

  svg {
    font-size: 26px;
  }

  div {
    width: 100%;
    padding: 8px 10px;
  }
`;
